angular.module('core')
  .controller('ConfirmModalController', ['$scope', '$modalInstance', 'args', function($scope, $modalInstance, $args) {

  $scope.okayButtonText = $args.okayButtonText;
  $scope.title = $args.title;
  $scope.message = $args.message;

   $scope.ok = function() {
       $scope.modalClose();
   };

   $scope.modalClose = function() {
       $modalInstance.close();
   };
}]);

